import React from "react";

const RenderBullet = () => {
  return (
    <i
      className="fa fa-circle-thin tw-align-middle"
      style={{
        marginRight: "0.2rem",
        fontSize: "0.4rem",
      }}
    />
  );
};

export default RenderBullet;
